import React, { useEffect, useState } from "react";
import { Popover, IconButton } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import "./notification.css";
import { formatDistanceToNow } from "date-fns";
import { useHistory } from "react-router-dom";
const NotificationModal = ({ anchorEl, onClose, notification }) => {
  const history = useHistory();

  const open = Boolean(anchorEl);
  const formatNotificationMessage = (message) => {
    const orderIdPattern = /Order ([\w-]+)/; 
    const match = message.match(orderIdPattern);

    if (match) {
      const fullOrderId = match[1];
      const truncatedOrderId = `${fullOrderId.slice(0, 7)}---`
      return message.replace(fullOrderId, truncatedOrderId);
    }

    return message;
  };
  const extractOrderId = (message) => {
    const orderIdPattern = /(Order|Shipment) ([\w-]+)/;
    const match = message.match(orderIdPattern);
    return match ? match[2] : null;
  };
  
  const handleNotificationClick = (message) => {
    const orderId = extractOrderId(message);
    if (orderId) {
      if (message.startsWith("Shipment")) {
        history.push(`/shipment/${orderId}`);
      } else {
        history.push(`/print/${orderId}`);
      }
      onClose();
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      className="notification-modal"
    >
      <div className="notification-modal-content">
        <div className="notification-header">
          <h4>Notifications</h4>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="notification-list">
          {notification?.length > 0 ? (
            notification.map((notification, index) => (
              <div
                onClick={() => handleNotificationClick(notification.message)}
                key={index}
                className="notification-item"
              >
                <p>{formatNotificationMessage(notification.message)}</p>
                <small>
                  {formatDistanceToNow(new Date(notification.createdAt), {
                    addSuffix: true,
                  })}
                </small>
              </div>
            ))
          ) : (
            <div>No new notifications</div>
          )}
        </div>
      </div>
    </Popover>
  );
};

export default NotificationModal;
